export const AI_RESPONSE_DISCLAIMER =
  'Disclaimer: This response has been generated using artificial intelligence and is provided for general information only. It does not constitute legal advice. For advice specific to your circumstances, please consult a suitably qualified and regulated legal professional, such as an adviser regulated by the IAA, an SRA-regulated solicitor or law firm, or a barrister regulated by the Bar Standards Board.';

export const hasAiDisclaimer = (content: string) =>
  content.includes(AI_RESPONSE_DISCLAIMER);

export const stripAiDisclaimer = (content: string) =>
  content.replace(AI_RESPONSE_DISCLAIMER, '').trimEnd();

export const withAiDisclaimer = (content: string) =>
  hasAiDisclaimer(content) ? content : `${content.trimEnd()}\n\n${AI_RESPONSE_DISCLAIMER}`;
